<div>
  <div class="modal-header pb-4">
    <div class="col">
      <h4 class="modal-title fw-bold" id="modal-basic-title">Bulk Upload Rates</h4>
      <span class="text-muted small">Select category and locations</span>
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
  </div>

  <div class="modal-body pt-3">

    <!-- Step progress indicator -->
    <div class="upload-stepper d-flex align-items-center justify-content-center mb-4">

      <div class="stepper-step"
        [class.active]="currentStep === 1 && !isPreviewed"
        [class.completed]="currentStep > 1 || isPreviewed">
        <div class="stepper-circle">
          <i class="bi bi-check" *ngIf="currentStep > 1 || isPreviewed"></i>
          <span *ngIf="!(currentStep > 1 || isPreviewed)">1</span>
        </div>
        <div class="stepper-label">Select Category</div>
      </div>

      <div class="stepper-line" [class.completed]="currentStep > 1 || isPreviewed"></div>

      <div class="stepper-step"
        [class.active]="currentStep === 2 && !isPreviewed"
        [class.completed]="isPreviewed">
        <div class="stepper-circle">
          <i class="bi bi-check" *ngIf="isPreviewed"></i>
          <span *ngIf="!isPreviewed">2</span>
        </div>
        <div class="stepper-label">Upload File</div>
      </div>

      <div class="stepper-line" [class.completed]="isPreviewed"></div>

      <div class="stepper-step"
        [class.active]="isPreviewed && !uploadSuccess"
        [class.completed]="uploadSuccess">
        <div class="stepper-circle">
          <i class="bi bi-check" *ngIf="uploadSuccess"></i>
          <span *ngIf="!uploadSuccess">3</span>
        </div>
        <div class="stepper-label">Review & Upload</div>
      </div>

    </div>

    <form [formGroup]="rateForm">

      <div class="wizard-step" [class.active]="currentStep === 1 && !isPreviewed">
        <div class="row gy-3">

          <div class="rounded-3 p-3">
            <h6 class="fw-semibold mb-3 text-secondary">
              <i class="bi bi-grid me-2"></i> Select Category
            </h6>
            <div class="row g-3">
              <div class="col-4" *ngFor="let cat of categoryTypeArray">
                <div
                  class="border rounded p-3 hover-bg-light cursor-pointer d-flex justify-content-between align-items-center"
                  [class]="
              'border rounded p-3 hover-bg-light cursor-pointer ' +
              (selectedCategoryID === cat.value ? 'border-secondary bg-secondary-subtle' : '')
            " (click)="onChangeCategory(cat)">

                  <div>
                    <div class="fw-semibold">{{ cat.label }}</div>
                    <div class="text-muted small">{{ cat.description }}</div>
                  </div>

                  <i class="bi bi-check text-secondary fs-4" *ngIf="selectedCategoryID === cat.value"></i>

                </div>
              </div>
            </div>
          </div>

        </div>


      </div>

      <div class="wizard-step" [class.active]="currentStep === 2 && !isPreviewed">
        <div class="d-flex align-items-start bg-info-subtle border border-info-subtle rounded p-4 gap-3 w-100">
          <i class="bi bi-info-circle-fill text-info fs-3"></i>
          <div class="row gy-2 flex-grow-1">
            <div class="fw-bold">
              Download Template First
            </div>
            <div>
              Download the CSV template specific to <span class="fw-bold">{{selectedCategory.toLowerCase()}}</span> to ensure your file has the correct format.
            </div>
            <div>
              <button type="button" (click)="downloadTemplate()" class="btn btn-primary"><i
                  class="bi bi-download text-info text-sm me-2"></i>Download
                Template</button>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-start bg-light border rounded p-2 gap-3 w-100 mt-4">
          <div class="flex-grow-1 text-small">
            <span class="fw-bold">Category:</span> {{selectedCategory}}
          </div>
        </div>

        <div class="drag-area mt-4"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onFileDrop($event)"
          [class.dragover]="isDragOver"
          [class.file-selected]="uploadedFile">

          <!-- Empty state -->
          <div class="text-center" *ngIf="!uploadedFile">
            <i class="bi bi-upload fs-1 text-secondary"></i>
            <p class="fw-bold mt-2 mb-0">Drag & drop your CSV file here, or click to browse</p>
            <p class="text-muted small mt-1">CSV files only</p>
          </div>

          <!-- File selected state -->
          <div class="text-center" *ngIf="uploadedFile">
            <i class="bi bi-file-earmark-spreadsheet fs-1 text-success"></i>
            <p class="fw-bold mt-2 mb-0">{{ uploadedFile.name }}</p>
            <p class="text-muted small mb-2">{{ formatFileSize(uploadedFile.size) }}</p>
            <a class="small text-secondary"
               style="cursor:pointer; position:relative; z-index:2;"
               (click)="clearFile(); $event.stopPropagation()">
              <i class="bi bi-x me-1"></i>Change file
            </a>
          </div>

          <input #fileInput type="file" accept=".csv" class="file-input" (change)="onFileSelect($event)">
        </div>

        <!-- Client-side file error -->
        <div class="mt-2 small text-danger" *ngIf="fileError">
          <i class="bi bi-exclamation-circle me-1"></i>{{ fileError }}
        </div>


      </div>

      <!-- Step 3: Review & Upload -->
      <div class="wizard-step" [class.active]="isPreviewed">

        <!-- ── Success state ── -->
        <div *ngIf="uploadSuccess" class="text-center py-3">
          <i class="bi bi-check-circle-fill text-success" style="font-size: 3.5rem;"></i>
          <h5 class="fw-bold mt-3">Upload Complete</h5>
          <p class="text-muted mb-3">Your rates have been uploaded successfully.</p>
          <div class="d-flex justify-content-center gap-0 flex-wrap">
            <div class="text-center px-3 border-end">
              <div class="fw-bold fs-5">{{ uploadSuccessStats?.total_rows || 0 }}</div>
              <div class="small text-muted text-uppercase">Total</div>
            </div>
            <div class="text-center px-3 border-end text-success">
              <div class="fw-bold fs-5">{{ (uploadSuccessStats?.created_rates || 0) + (uploadSuccessStats?.updated_rates || 0) }}</div>
              <div class="small text-muted text-uppercase">Processed</div>
            </div>
            <div class="text-center px-3" [class.text-warning]="(uploadSuccessStats?.skipped_routes || 0) > 0">
              <div class="fw-bold fs-5">{{ uploadSuccessStats?.skipped_routes || 0 }}</div>
              <div class="small text-muted text-uppercase">Skipped</div>
            </div>
          </div>
        </div>

        <!-- ── Validation / error state ── -->
        <div *ngIf="!uploadSuccess">

          <!-- Status banner -->
          <div *ngIf="uploadHardError" class="alert alert-danger d-flex align-items-center gap-2 py-2 mb-3">
            <i class="bi bi-x-circle-fill"></i>
            <span>Upload failed — see errors below</span>
          </div>
          <div *ngIf="!uploadHardError && (previewData?.errors?.length || 0) > 0"
               class="alert alert-warning d-flex align-items-center gap-2 py-2 mb-3">
            <i class="bi bi-exclamation-triangle-fill"></i>
            <span>Issues found — review before uploading</span>
          </div>
          <div *ngIf="!uploadHardError && (previewData?.errors?.length || 0) === 0"
               class="alert alert-success d-flex align-items-center gap-2 py-2 mb-3">
            <i class="bi bi-check-circle-fill"></i>
            <span>Validation passed — ready to upload</span>
          </div>

          <!-- Stats cards -->
          <div class="row g-2 mb-3">
            <div class="col-6">
              <div class="p-2 border rounded bg-light shadow-sm h-100">
                <div class="text-muted small text-uppercase fw-bold" style="font-size:0.7rem;">Total Rows</div>
                <div class="fs-5 fw-bold">{{ previewData?.total_rows || 0 }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="p-2 border rounded bg-light shadow-sm h-100">
                <div class="text-muted small text-uppercase fw-bold" style="font-size:0.7rem;">Valid</div>
                <div class="fs-5 fw-bold text-success">{{ (previewData?.created_rates || 0) + (previewData?.updated_rates || 0) }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="p-2 border rounded bg-light shadow-sm h-100">
                <div class="text-muted small text-uppercase fw-bold" style="font-size:0.7rem;">New</div>
                <div class="fw-bold">{{ previewData?.new_routes || 0 }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="p-2 border rounded bg-light shadow-sm h-100">
                <div class="text-muted small text-uppercase fw-bold" style="font-size:0.7rem;">Updated</div>
                <div class="fw-bold">{{ previewData?.updated_routes || 0 }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="p-2 border rounded bg-light shadow-sm h-100">
                <div class="text-muted small text-uppercase fw-bold" style="font-size:0.7rem;">Skipped</div>
                <div class="fw-bold" [class.text-warning]="previewData?.skipped_routes > 0">{{ previewData?.skipped_routes || 0 }}</div>
              </div>
            </div>
          </div>

          <!-- Errors / Warnings tabs -->
          <div class="mt-3"
               *ngIf="(previewData?.errors?.length || 0) > 0 || (previewData?.warnings?.length || 0) > 0">
            <ul class="nav nav-tabs">
              <li class="nav-item" *ngIf="(previewData?.errors?.length || 0) > 0"
                  (click)="setActiveTab('errors')">
                <a class="nav-link cursor-pointer text-danger"
                   [class.active]="activeTab === 'errors'">
                  Errors ({{ previewData?.errors?.length || 0 }})
                </a>
              </li>
              <li class="nav-item" *ngIf="(previewData?.warnings?.length || 0) > 0"
                  (click)="setActiveTab('warnings')">
                <a class="nav-link cursor-pointer text-warning"
                   [class.active]="activeTab === 'warnings'">
                  Warnings ({{ previewData?.warnings?.length || 0 }})
                </a>
              </li>
            </ul>

            <div class="tab-content border border-top-0 rounded-bottom bg-white"
                 style="max-height: 200px; overflow-y: auto;">

              <div *ngIf="activeTab === 'errors'">
                <table class="table table-sm table-hover mb-0">
                  <thead class="bg-light sticky-top">
                    <tr>
                      <th class="px-3 py-2 text-center" style="width:80px;">Row</th>
                      <th class="px-3 py-2">Problem Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let err of previewData?.errors">
                      <td class="px-3 py-2 text-center fw-bold text-secondary bg-light">{{ err.row }}</td>
                      <td class="px-3 py-2 text-danger">{{ err.error || err.message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div *ngIf="activeTab === 'warnings'">
                <table class="table table-sm table-hover mb-0">
                  <thead class="bg-light sticky-top">
                    <tr>
                      <th class="px-3 py-2 text-center" style="width:80px;">Row</th>
                      <th class="px-3 py-2">Warning Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let warn of previewData?.warnings">
                      <td class="px-3 py-2 text-center fw-bold text-secondary bg-light">{{ warn.row }}</td>
                      <td class="px-3 py-2 text-warning">{{ warn.message || warn.warning || warn.error }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>

    </form>



  </div>

  <div class="modal-footer d-flex justify-content-between">

    <!-- Normal flow: Cancel on the left -->
    <button class="btn btn-light" *ngIf="!uploadSuccess" (click)="closeModal()">Cancel</button>

    <!-- Normal flow: navigation buttons on the right -->
    <div class="d-flex flex-row gap-3" *ngIf="!uploadSuccess">

      <!-- Prev: visible on step 2 or in preview/error state -->
      <button class="btn btn-outline-secondary"
        *ngIf="currentStep !== 1 || isPreviewed"
        [disabled]="isSubmitting"
        (click)="goToPrevStep()">
        Prev
      </button>

      <!-- Step 1 → Step 2 -->
      <button class="btn btn-secondary text-white"
        *ngIf="!isSaveButtonEnabled && !isPreviewed"
        [disabled]="!selectedCategoryID"
        (click)="goToNextStep()">
        Next
      </button>

      <!-- Step 2 → Validate -->
      <button class="btn btn-secondary text-white"
        *ngIf="isSaveButtonEnabled && !isPreviewed"
        [disabled]="!uploadedFile || !!fileError || isSubmitting"
        (click)="handleBulkUpload()">
        <span *ngIf="!isSubmitting">Validate & Preview</span>
        <span *ngIf="isSubmitting"><i class="bi bi-arrow-repeat spin"></i> Validating...</span>
      </button>

      <!-- Step 3 → Upload (hidden on hard error) -->
      <button class="btn btn-success text-white"
        *ngIf="isPreviewed && !uploadHardError"
        [disabled]="isSubmitting"
        (click)="handleBulkUpload()">
        <span *ngIf="!isSubmitting">Proceed to Upload</span>
        <span *ngIf="isSubmitting"><i class="bi bi-arrow-repeat spin"></i> Uploading...</span>
      </button>

    </div>

    <!-- Success state: full-width Done button -->
    <div *ngIf="uploadSuccess" class="w-100 text-end">
      <button class="btn btn-success text-white px-4" (click)="closeAndReset()">
        Done
      </button>
    </div>

  </div>
</div>
